import { DEFAULT_MAX_PRICE_DIFF_RATIO } from '~/consts'

export function getChannelPriceRatio(channelId: number) {
    switch (channelId) {
        default:
            return 1 - DEFAULT_MAX_PRICE_DIFF_RATIO
    }
}
